import FooterLinksWidget from './FooterLinksWidget';
import SocialNetworksWidget from './SocialNetworksWidget';
import PositionWidget from './PositionWidget';

export function registerWidgets(config) {
  // Registra widgets para os control panels
  config.widgets.widget.social_networks_widget = SocialNetworksWidget;
  config.widgets.widget.footer_links_widget = FooterLinksWidget;
  config.widgets.widget.position_widget = PositionWidget;

  return config;
}
